import * as React from "react";
const SvgFiRrPeopleCarryBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-people-carry-box_svg__a)">
      <path
        fill="#062147"
        d="M3 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M18.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M2.418 18.038a1.004 1.004 0 0 0-1.236.688l-1.144 4a1 1 0 1 0 1.923.548l1.143-4a1 1 0 0 0-.686-1.236m21.543 4.688-1.143-4a1.004 1.004 0 0 0-1.236-.688 1 1 0 0 0-.687 1.236l1.143 4a1 1 0 0 0 1.923-.548m-1.824-6.712L19 18.059V23a1 1 0 1 1-2 0v-5.483c0-.338.171-.653.454-.838l1.497-.975-1.633-6.115L16 11.809V14.5c0 1.379-1.122 2.5-2.5 2.5h-3A2.503 2.503 0 0 1 8 14.5v-2.691L6.69 9.598 5.1 15.735l1.446.943c.283.185.454.5.454.838v5.483a1 1 0 1 1-2 0v-4.941l-3.149-2.053a4.01 4.01 0 0 1-1.768-4.181L.83 9.063C1.19 7.313 2.803 6 4.65 6c1.376 0 2.666.735 3.368 1.919l.957 1.614A2.47 2.47 0 0 1 10.5 9h3c.577 0 1.102.204 1.525.533l.958-1.614A3.93 3.93 0 0 1 19.35 6a3.93 3.93 0 0 1 3.834 3.123l.72 2.642c.348 1.681-.367 3.364-1.767 4.249M3.332 14.583l1.692-6.534A2 2 0 0 0 4.651 8c-.904 0-1.693.643-1.875 1.527l-.747 2.761c-.154.751.204 1.593.903 2.034zM14 11.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm7.958.729-.719-2.642C21.042 8.643 20.253 8 19.35 8c-.127 0-.25.025-.373.049l1.737 6.505.344-.224a2.01 2.01 0 0 0 .901-2.102z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-people-carry-box_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeopleCarryBox;
